let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bJ9de")).then(() => parcelRequire('g7lF5'));